import { Injectable } from '@angular/core';
import { TealiumUtagService } from '../../assets/ts/utag.service';
import { Router } from '@angular/router';
import { routes } from '../../app/routes.constant';
import { appLabels } from '../../app/app-constant';

@Injectable()
export class TagsService {

  constructor(private tealiumUtagService: TealiumUtagService, private router: Router) { }
  

  setConfig() {
    this.tealiumUtagService.setConfig({
      "account" : "hsbc",
      "profile" : "global-gbm-digitalvault",
      "environment" : "prod"
    });
  }

  view(data) {
    let pageData: any = this.getPageData();
    let viewData = {
      "site_region" : "Global",
      "site_subregion" : "Global",
      "site_country": "Global",
      "site_entity": "HSBC Bank Plc",
      "site_brand": "HSBC",
      "page_business_line": "GBM",
      "page_customer_group": "Business",
      "page_channel": "Web",
      "page_url": "/hsbcnet/digital vault - client/" + pageData.pageName,
      "page_language": "English",
      "page_type": "Account",
      "page_category": "digital vault - client",
      "page_name": "hsbcnet : digital vault - client : " + pageData.pageName
    };
    console.log('Analytics ' + this.router.url + ' ' +pageData.pageName);
    //let tagData = Object.assign(viewData, data);
    this.tealiumUtagService.view(viewData);
  }

  link(data) {
    let pageData: any = this.getPageData();
    let linkData = {
      "event_category": "content",
      "page_category": "digital vault - client",
      "page_name" : "hsbcnet : digital vault - client : " + pageData.pageName,
      "event_action": "",
      "event_content": ""
    };
    //let tagData = Object.assign(linkData, data);
    linkData.event_action = data.event_action;
    linkData.event_content = "digital vault - client : " + pageData.pageName + " : " + data.event_content;
    this.tealiumUtagService.link(linkData);
  }

  getPageData() {
    let pageName;
    let pageUrl;
    let curretUrl = this.router.url;

    switch(curretUrl) {
      case routes.LOGIN:
        pageName = "Login";
        pageUrl = "hsbcnet/digital vault - client/login";
        break;
      case routes.HOLD_TRANSACTIONS_HOLDINGS:
        pageName = 'holdings';
        pageUrl = "hsbcnet/digital vault - client/"+appLabels.HOLDINGS.toLowerCase();
        break;
      case routes.BUY_TRANSACTIONS:
        pageName = 'buy transactions';
        pageUrl = "hsbcnet/digital vault - client/"+appLabels.BUY_TRANSACTIONS.toLowerCase();
        break;
      case routes.SELL_TRANSACTIONS:
        pageName = 'sell transactions';
        pageUrl = "hsbcnet/digital vault - client/"+appLabels.SELL_TRANSACTIONS.toLowerCase();
        break;
      case routes.SEC_MASTER:
        pageName = 'security master';
        pageUrl = "hsbcnet/digital vault - client/"+appLabels.SEC_MASTER.toLowerCase();
        break;
      case routes.HELP:
        pageName = 'help';
        pageUrl = "hsbcnet/digital vault - client/"+appLabels.HELP.toLowerCase();
        break;
    }

    console.log(curretUrl, {
      pageName: pageName,
      pageUrl: pageUrl
    });

    return {
      pageName: pageName,
      pageUrl: pageUrl
    };
  }
}
